var InvitedList = [
  {
    id: 0,
    name: 'Sarath Sreedharan',
    image: 'sarath',
    affiliation: 'Colorado State University',
    link: 'http://sarathsreedharan.com/',
  }
];

var PanelList = [];

var OrganizingTeamList = [
  {
    id: 1,
    name: 'Rebecca Eifler',
    image: 'rebecca',
    affiliation: 'LAAS-CNRS',
    link: 'http://fai.cs.uni-saarland.de/eifler/',
  },
  {
    id: 2,
    name: 'Benjamin Krarup',
    image: 'ben',
    affiliation: 'Kings College London',
    link: 'https://uk.linkedin.com/in/benjamin-krarup',
  },
  {
    id: 3,
    name: 'Alan Lindsay',
    image: 'alanL',
    affiliation: 'Heriot-Watt University',
    link: 'https://researchportal.hw.ac.uk/en/persons/alan-lindsay',
  },
  {
    id: 4,
    name: 'Lindsay Sanneman',
    image: 'lindsay',
    affiliation: 'MIT',
    link: 'https://www.lindsaysanneman.com/',
  },
  {
    id: 6,
    name: 'Silvia Tulli',
    image: 'silvia',
    affiliation: 'Sorbonne University',
    link: 'https://silviatulli.com/',
  },
  {
    id: 7,
    name: 'Stylianos Vasileiou',
    image: 'stylianos',
    affiliation: 'Washington University',
    link: 'https://thestlucas.com/',
  },
];

var SteeringCommitteeList = [
  {
    id: 8,
    name: 'Jeremy Frank',
    image: 'frank',
    affiliation: 'NASA',
    link: 'https://www.nasa.gov/content/jeremy-frank',
  },
  {
    id: 9,
    name: 'Claudia Goldman',
    image: 'claudia',
    affiliation: 'General Motors',
    link: 'https://il.linkedin.com/in/claudiagoldman',
  },
  {
    id: 10,
    name: 'Jörg Hoffmann',
    image: 'joerg',
    affiliation: 'Saarland University',
    link: 'http://fai.cs.uni-saarland.de/hoffmann/',
  },
  {
    id: 11,
    name: 'Subbarao Kambhampati',
    image: 'rao',
    affiliation: 'Arizona State University',
    link: 'https://rakaposhi.eas.asu.edu/',
  },
  {
    id: 6,
    name: 'David Smith',
    image: 'david',
    affiliation: 'PS Research',
    link: 'http://psresearch.xyz/',
  },
  {
    id: 7,
    name: 'William Yeoh',
    image: 'william',
    affiliation: 'Washington University in St. Louis',
    link: 'https://sites.wustl.edu/wyeoh/',
  },
];

var PCList = [
  {
    id: 0,
    name: 'Gerard Canal',
    affiliation: 'King\'s College London',
  },
  {
    id: 1,
    name: 'Derek Long',
    affiliation: 'King\'s College London',
  },
  {
    id: 2,
    name: 'Ashwin Kumar',
    affiliation: 'Washington University',
  },
  {
    id: 3,
    name: 'Sriram Gopalakrishnan',
    affiliation: 'J.P. Morgan Chase',
  },
  {
    id: 4,
    name: 'Pascal Tobias Bercher',
    affiliation: 'Australian National University',
  },
  {
    id: 5,
    name: 'Emile Siboulet',
    affiliation: 'LAAS / CNRS',
  },
  {
    id: 5,
    name: 'Mohammad Yousefi',
    affiliation: 'Australian National University',
  },
  {
    id: 6,
    name: 'Forest Agostinelli',
    affiliation: 'University of South Carolina',
  },
  {
    id: 7,
    name: 'Elmira Yadollahi',
    affiliation: 'KTH Royal Institute of Technology',
  },
  {
    id: 8,
    name: 'Siddhant Bhambri',
    affiliation: 'Arizona State University',
  },
  {
    id: 9,
    name: 'Miguel Faria',
    affiliation: 'Instituto de Telecomunicações',
  },
  {
    id: 10,
    name: 'Hendrik Baier',
    affiliation: 'Eindhoven University of Technology',
  },
  {
    id: 11,
    name: 'Virgile de La Rochefoucauld',
    affiliation: 'Institut National des Sciences Appliquées de Toulouse',
  },
  {
    id: 12,
    name: 'Toryn Q. Klassen',
    affiliation: 'University of Toronto',
  },
  {
    id: 12,
    name: 'Alberto Candela',
    affiliation: 'Jet Propulsion Laboratory',
  },
  {
    id: 13,
    name: 'Alban Grastien',
    affiliation: 'CEA',
  },
];

var ProjectList = [
  {
    id: 8,
    name: 'TUPLES',
    image: 'tuples',
    link: 'https://tuples.ai/',
  },
];

export {
  OrganizingTeamList,
  SteeringCommitteeList,
  PCList,
  InvitedList,
  PanelList,
  ProjectList,
};
